import Interpolate from '@doist/react-interpolate';
import { UseFormRegisterReturn } from 'react-hook-form';

import { Link } from '~/shared/ui/Link/Link';
import { Switch } from '~/shared/ui/Switch/Switch';

import { useLocalization } from '../../../localization/localization';

import { Root } from './OfferToggle.ui';

const OFFER_URL = '/documents/offer.pdf';

type OfferToggleProps = UseFormRegisterReturn & {
  rootClassName?: string;
};

export const OfferToggle = ({
  rootClassName,
  ...restProps
}: OfferToggleProps) => {
  const { t } = useLocalization();

  return (
    <Root className={rootClassName}>
      <Switch {...restProps} />
      <span>
        <Interpolate
          mapping={{
            link: <Link href={OFFER_URL} target="_blank" />,
          }}
          string={t('I accept the terms of the offer')}
        />
      </span>
    </Root>
  );
};
